import React from 'react';

import {AuditLogReportType} from 'audit/AuditDAO';
import PrimaryFilterFormSkeleton from 'search/filters/base/PrimaryFilterFormSkeleton';
import {ButtonSize} from 'ui-library/buttons/Button';
import {MenuWidth} from 'ui-library/menus/MenuConstants';
import MenuPopover from 'ui-library/menus/MenuPopover';
import Option from 'ui-library/menus/Option';

const LABEL = 'Report type';

export interface AuditLogReportTypeOption {
  value: AuditLogReportType;
  label: string;
}

export interface AuditLogReportTypeFilterDropdownProps {
  options: Array<AuditLogReportTypeOption>;
  value: AuditLogReportType | undefined;
  onChange: (value: AuditLogReportType) => void;
  disabled?: boolean;
}

export default function AuditLogReportTypeFilterDropdown({
  options,
  value,
  onChange,
  disabled = false,
}: AuditLogReportTypeFilterDropdownProps): JSX.Element {
  const selectedLabel = options.find((option) => option.value === value)?.label;
  const dropdownToggleText = selectedLabel ? `${LABEL}: ${selectedLabel}` : LABEL;

  return (
    <div>
      <PrimaryFilterFormSkeleton
        buttonSize={ButtonSize.SMALL}
        dropdownToggleText={dropdownToggleText}
        menuOverride={
          <MenuPopover width={MenuWidth.MEDIUM}>
            {options.map((option) => (
              <Option
                key={option.value}
                isSelected={option.value === value}
                onSelect={() => {
                  onChange(option.value);
                }}
              >
                {option.label}
              </Option>
            ))}
          </MenuPopover>
        }
        closeOnInsideClick={true}
        isActive={false}
        isDisabled={disabled}
        tooltipTitle={null}
      />
    </div>
  );
}
